module.exports = __webpack_public_path__ + "img/IA.475c3084.png";